import { useState } from "react";
import { View } from "react-native";
import TrunkLeafNavigation from "src/components/TrunkLeafNavigation/TrunkLeafNavigation";
import { useInsideModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import { enumNever } from "src/shared/helpers/generalHelpers";
import GatheringFilterSortFooter from "./components/GatheringFilterSortFooter";
import GatheringFilterSortContext, {
	GatheringFilterSortContextType,
} from "./contexts/GatheringFilterSortContext";
import { useGatheringFilterSortModalDimensions } from "./GatheringFilterSortModalSkeleton";
import GatheringFilterSortAllPeople from "./screens/GatheringFilterSortAllPeople";
import GatheringFilterSortAllUploaders from "./screens/GatheringFilterSortAllUploaders";
import GatheringFilterSortMain from "./screens/GatheringFilterSortMain";
import { createGatheringFilterSortStore } from "./stores/gatheringFilterSortStore";
import { GatheringFilterSortNavigationProps } from "./types";

const renderTrunk = () => {
	return <GatheringFilterSortMain />;
};
const renderLeaf = ({ variant }: GatheringFilterSortNavigationProps) => {
	switch (variant) {
		case "AllPeople":
			return <GatheringFilterSortAllPeople />;
		case "AllUploaders":
			return <GatheringFilterSortAllUploaders />;
		default:
			return enumNever(variant);
	}
};

const GatheringFilterSortModal = () => {
	const { props, closeSelf } = useInsideModal<GatheringModal["GatheringFilterSortModal"]>();
	const [value] = useState<GatheringFilterSortContextType>(() => {
		const store = createGatheringFilterSortStore({
			...props,
			closeSelf,
		});
		return { store } satisfies GatheringFilterSortContextType;
	});
	const style = useGatheringFilterSortModalDimensions();

	return (
		<GatheringFilterSortContext.Provider value={value}>
			<View style={style}>
				<View
					style={{
						flex: 1,
					}}
				>
					<TrunkLeafNavigation
						renderTrunkScreen={renderTrunk}
						renderLeafScreen={renderLeaf}
						onNavigation={({ screen }) => {
							value.store.setState({
								currentScreen: screen,
							});
						}}
					/>
				</View>
				<GatheringFilterSortFooter />
			</View>
		</GatheringFilterSortContext.Provider>
	);
};
export default GatheringFilterSortModal;
